/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  tooltip: {
    fontSize: '1rem',
    padding: '0.375rem 1.5rem',
    lineHeight: '2rem',
  },
  emptyTableIcon: {
    margin: '0 0 1rem 0',
    fontSize: '5rem',
    color: theme.palette.error.main,
  },
  errorTableIcon: {
    margin: '0 0 1rem 0',
    fontSize: '5rem',
    color: theme.palette.error.main,
  },
  combinedColumn: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  iconButton: {
    padding: '0.5rem',
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.white,
      color: theme.palette.secondary.contrastText,
    },
  },
  lineCheckbox: {
    marginRight: '1rem',
  },
  noRightBorder: {
    borderRight: '0',
  },
  emptyTable: {
    height: '32rem',
  },
  errorRow: {
    '& td': {
      backgroundColor: theme.palette.backgroundError,
    },
  },
  unwrappedTableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  moreIcon: {
    backgroundColor: theme.palette?.moreIcon?.backgroundColor || 'transparent',
    color: theme.palette?.moreIcon?.color || theme.palette.tableMoreIconColor,
    '&:hover': {
      backgroundColor: theme.palette?.moreIcon?.hover?.backgroundColor || theme.palette.white,
      color: theme.palette?.moreIcon?.hover?.color || theme.palette.secondary.contrastText,
    },
    '&:active, &:focus': {
      backgroundColor: theme.palette?.moreIcon?.active?.backgroundColor || theme.palette.white,
      color: theme.palette?.moreIcon?.active?.color || theme.palette.secondary.contrastText,
    },
    '&[data-focustype="key"]': {
      backgroundColor: theme.palette?.moreIcon?.focus?.backgroundColor || theme.palette.white,
      color: theme.palette?.moreIcon?.focus?.color || theme.palette.secondary.contrastText,
    },
  },
  activeIcon: {
    backgroundColor: `${theme.palette.selectedIconButton}`,
    color: theme.palette.white,
  },
}));

export default useStyles;
